import React from 'react';
import Politcs from '../components/Politcs'

function PolitcsPage() {
  return (
    <div>
      <Politcs />
    </div>
  );
}

export default PolitcsPage;
